<template>
  <div class="app-container" style="padding-top: 35px">
    <!-- 搜索部分 -->
    <div style="display: flex; flex-wrap: wrap; gap: 8px 0">
      <div>
        <el-input
            v-model="searchForm.keyka"
            size="small"
            placeholder="搜索novalai-apikey"
            class="search-input"
            @input="handleSearch">
        </el-input>
      </div>

      <div>
        <el-button type="primary" size="small" @click="fetchApikeys">搜索</el-button>
      </div>
      <div>
        <el-button type="primary" size="small" style="margin-left: 10px;" @click="AddApikeys">新增</el-button>
      </div>
      <div>
        <el-button type="primary" size="small" style="margin-left: 10px;">批量删除</el-button>
      </div>
      <el-button type="primary" size="small" style="margin-left: 10px;" @click="rotationVisible = true">1 级轮询备用 API</el-button>
      <div>
        <el-button
            type="primary"
            size="small"
            style="margin-left: 10px;"
            :loading="loading"
            @click="reinitializePools">
          同步池配置
        </el-button>
      </div>
    </div>

    <level-one-rotation-dialog :visible="rotationVisible" @close="rotationVisible = false" @changed="fetchApikeys" />
    <p class="pool-hint">新增、修改和删除会自动同步；在用 Token 完成当前请求后应用变更。运行状态每 5 秒刷新。</p>
    <el-alert v-if="poolStatusUnavailable" title="运行状态获取失败，下面显示的可能是上次状态。"
              type="warning" :closable="false" show-icon class="pool-alert" />
    <el-alert v-else-if="poolStatus && !poolStatus.refreshHealthy"
              title="后台数据库同步失败，运行池保留最后一次成功配置。"
              type="warning" :closable="false" show-icon class="pool-alert" />
    <el-alert v-if="poolStatus && !poolStatus.persistenceHealthy"
              title="冷却和隔离状态文件保存失败，请修复存储后再重启服务。"
              type="error" :closable="false" show-icon class="pool-alert" />

    <div style=" display: flex; align-items: center; justify-content: center; margin-top: 20px">
      <el-table
          :data="rowsWithPoolState"
          border
          style="width: 100%; overflow-y: auto; max-height: 500px;"
          @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            width="55px">
        </el-table-column>
        <el-table-column
            type="index"
            label="序号"
            width="55px">
        </el-table-column>
        <el-table-column
            prop="keyLevel"
            label="级别"
            width="50">
        </el-table-column>
        <el-table-column
            prop="keyApi"
            label="ApiKey值"
            width="360px"
            show-overflow-tooltip>
        </el-table-column>
<!--        <el-table-column-->
<!--            prop="isLimit"-->
<!--            label="活动点"-->
<!--            width="60">-->
<!--        </el-table-column>-->
        <el-table-column
            prop="isLimit"
            label="测试"
            width="75">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isLimit === '1'" type="info">异常</el-tag>
            <el-tag v-else type="success">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="isSurvive"
            label="是否可用"
            width="75">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSurvive === '0'" type="info">不可用</el-tag>
            <el-tag v-else type="success">可用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="email"
            label="邮箱"
            width="130">
        </el-table-column>
        <el-table-column
            prop="expirationTime"
            label="过期时间"
            width="130">
        </el-table-column>
        <el-table-column label="运行状态" width="285" fixed="right">
          <template slot-scope="scope">
            <div v-if="scope.row.poolState" class="pool-state">
              <div>当前 {{ poolLevel(scope.row.poolState.active ? scope.row.poolState.acquiredLevel : scope.row.poolState.desiredLevel) }}
                / 目标 {{ poolLevel(scope.row.poolState.desiredLevel) }}</div>
              <div class="pool-tags">
                <el-tag v-if="scope.row.poolState.isolated" type="danger" size="mini">免费隔离</el-tag>
                <el-tag v-if="scope.row.poolState.active" size="mini">请求进行中</el-tag>
                <el-tag v-if="scope.row.poolState.pendingChange" type="warning" size="mini">结束后应用变更</el-tag>
                <el-tag v-if="scope.row.poolState.cooldownUntil > poolNow" type="warning" size="mini">冷却中</el-tag>
                <el-tag v-if="!scope.row.poolState.enabled" type="info" size="mini">已停用</el-tag>
                <el-tag v-else-if="scope.row.poolState.expiresAt > 0 && scope.row.poolState.expiresAt <= poolNow"
                        type="info" size="mini">已过期</el-tag>
                <el-tag v-if="scope.row.poolState.availableNow" type="success" size="mini">{{ scope.row.poolState.desiredLevel === 7 ? '付费可借用' : '可借用' }}</el-tag>
                <el-tag v-else-if="!scope.row.poolState.active && !scope.row.poolState.isolated && scope.row.poolState.enabled && scope.row.poolState.cooldownUntil <= poolNow && (!scope.row.poolState.expiresAt || scope.row.poolState.expiresAt > poolNow)"
                        type="info" size="mini">暂不可借用</el-tag>
              </div>
              <div>连续 403：{{ scope.row.poolState.consecutive403 }}</div>
              <div v-if="scope.row.poolState.cooldownUntil > poolNow">冷却至 {{ formatDate(scope.row.poolState.cooldownUntil) }}</div>
            </div>
            <span v-else class="pool-hint">{{ poolMissingText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="195" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" circle @click="handleUpdate(scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button type="text" circle @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i>
            </el-button>
            <el-button v-if="scope.row.poolState && (scope.row.poolState.isolated || scope.row.poolState.consecutive403 > 0)"
                       type="text" size="mini" :loading="resettingRiskId === scope.row.id"
                       :disabled="poolStatusUnavailable || (poolStatus && !poolStatus.refreshHealthy) || resettingRiskId !== null"
                       @click="resetPoolRisk(scope.row)">
              恢复并允许重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div>
      <!-- 分页 -->
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalKamils">
      </el-pagination>
    </div>
    <el-dialog
        :title="formtile"
        :visible.sync="dialogVisible"
        width="30%"
        @close="handleDialogClose">
      <el-form :model="currentRow">
        <!-- ... 其他表单项 ... -->
        <el-form-item label="级别" :label-width="formLabelWidth">
          <el-input v-model="currentRow.keyLevel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="apikey值" :label-width="formLabelWidth">
          <el-input v-model="currentRow.keyApi" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="currentRow.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="可用性" :label-width="formLabelWidth">
          <el-switch
              v-model="currentRow.isSurvive"
              active-value="1"
              inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="过期时间" :label-width="formLabelWidth">
          <el-date-picker
              v-model="currentRow.expirationTime"
              type="datetime"
              placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              autocomplete="off">
          </el-date-picker>
        </el-form-item>
        <!-- ... 其他表单项 ... -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <!-- 根据 isEditMode 来决定点击按钮是调用新增还是编辑函数 -->
        <el-button type="primary" @click="isEditMode ? handleUpdateConfirm() : handleAddConfirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import LevelOneRotationDialog from '@/components/LevelOneRotationDialog.vue';

export default {
  components: { LevelOneRotationDialog },
  data() {
    return {
      rotationVisible: false,
      formtile:'新增apikey',
      isEditMode: false, // 新增一个变量来判断当前是新增模式还是编辑模式
      dialogVisible : false,
      searchForm: {
        keyka: ''
      },
      kamils: [],
      totalKamils: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [],
      currentRow: {}, // 当前正在编辑的行
      formLabelWidth: '120px',
      loading: false,
      poolStatus: null,
      poolStatusUnavailable: false,
      poolStatusLoading: false,
      poolPollTimer: null,
      poolNow: Date.now(),
      resettingRiskId: null
    };
  },
  computed: {
    rowsWithPoolState() {
      const states = new Map((this.poolStatus?.tokens || []).map(state => [String(state.recordId), state]));
      return this.kamils.map(row => ({ ...row, poolState: states.get(String(row.id)) }));
    }
  },
  methods: {
    requireSuccess(response) {
      if (Number(response?.data?.code) !== 200) {
        throw new Error(response?.data?.msg || response?.data?.message || '请求未成功');
      }
      return response.data;
    },
    errorMessage(error) {
      return error.response?.data?.msg || error.response?.data?.message || error.message || '请求失败';
    },
    async fetchPoolStatus() {
      if (this.poolStatusLoading) return;
      this.poolStatusLoading = true;
      this.poolNow = Date.now();
      try {
        const response = await axios.get('/api/admin/apiKeys/pool-status', {
          headers: { token: this.$cookies.get('token') }, timeout: 8000
        });
        this.poolStatus = this.requireSuccess(response).data;
        this.poolStatusUnavailable = false;
      } catch (error) {
        this.poolStatusUnavailable = true;
      } finally {
        this.poolStatusLoading = false;
      }
    },
    poolLevel(level) {
      return level == null || level < 0 ? '移出池' : `${level} 级`;
    },
    poolMissingText(row) {
      if (this.poolStatusUnavailable) return '状态获取失败';
      if (!this.poolStatus) return '正在获取状态';
      return ['0', '1', '2', '5', '7'].includes(String(row.keyLevel)) ? '待同步或未配置' : '此级别不使用该池';
    },
    async resetPoolRisk(row) {
      try {
        await this.$confirm('恢复会清除该 Token 的冷却和 403 隔离，允许重新发起请求；正在执行的请求仍保持独占。确认恢复吗？', '恢复并允许重试', {
          confirmButtonText: '恢复并允许重试', cancelButtonText: '取消', type: 'warning'
        });
        this.resettingRiskId = row.id;
        const response = await axios.post(`/api/admin/apiKeys/${row.id}/reset-risk`, {}, {
          headers: { token: this.$cookies.get('token') }
        });
        const result = this.requireSuccess(response);
        if (result.data && result.data.persistenceHealthy === false) {
          this.$message.warning(result.msg);
        } else {
          this.$message.success(result.msg || result.data || '已恢复，允许重试');
        }
        await this.fetchPoolStatus();
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error(this.errorMessage(error));
      } finally {
        this.resettingRiskId = null;
      }
    },
    async reinitializePools() {
      try {
        this.loading = true;
        const response = await axios.post(`/api/admin/apiKeys/reinit-pools`, {}, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        const result = this.requireSuccess(response);
        this.$message.success(result.msg || result.data || '池配置已同步');
        await this.fetchPoolStatus();
      } catch (error) {
        if (error === 'cancel') {
          return; // 用户点击了取消
        }
        this.$message.error('池配置同步失败: ' + this.errorMessage(error));
      } finally {
        this.loading = false;
      }
    },
    AddApikeys() {
      this.clearCurrentRow();
      this.dialogVisible = true;
      this.isEditMode = false; // 设置为新增模式
      this.formtile = '新增apikey';
    },
    handleUpdate(scopeRow) {
      this.currentRow = { ...scopeRow };
      this.dialogVisible = true;
      this.isEditMode = true; // 设置为编辑模式
      this.formtile = '编辑apikeys'
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除这个key吗?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        this.loading = true;

        // 注意：这里我们将ids作为查询参数传递，而不是在请求体中
        const response = await axios.delete(`/api/admin/apiKeys/delete?ids=${row.id}`, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });
        // 处理正常响应
        this.requireSuccess(response);
        this.$message.success('key成功被删除');
        await this.fetchApikeys();

      } catch (error) {
        if (error !== 'cancel' && error !== 'close') this.$message.error('key删除错误: ' + this.errorMessage(error));
      } finally {
        this.loading = false;
      }
    },
    clearCurrentRow() {
      this.currentRow = { isSurvive: '1' };
    },
    async handleUpdateConfirm()  {
      try {
        // 设置loading为true，表示开始处理更新请求
        this.loading = true;

        // 创建 PUT 请求的请求体，确保包含 id 字段
        const requestBody = {
          id: this.currentRow.id, // 确保这里提供了id
          keyLevel: this.currentRow.keyLevel,
          email: this.currentRow.email,
          keyApi: this.currentRow.keyApi,
          expirationTime: this.currentRow.expirationTime,
          isSurvive: this.currentRow.isSurvive,
        };

        // 发送 PUT 请求到 /update 路径
        const response = await axios.put(`/api/admin/apiKeys/update`, requestBody, {
          headers: {
            'token': this.$cookies.get('token') // 通过请求头发送token
          }
        });

        // 处理正常响应
        const result = this.requireSuccess(response);
        this.dialogVisible = false;
        this.$message.success(result.msg || 'key成功更新，运行池自动同步');

        // 可能需要更新列表或执行其他相关操作
        // ...
        await this.fetchApikeys();

      } catch (error) {
        // 处理错误
        this.$message.error('key更新失败: ' + this.errorMessage(error));
      } finally {
        this.loading = false; // 结束更新请求，无论成功或失败，设置loading为false
      }
    },
    async handleAddConfirm() {
      try {
        // 设置loading为true，表示开始处理添加请求
        this.loading = true;

        // 创建 POST 请求的请求体，不包含 id 字段
        const requestBody = {
          keyLevel: this.currentRow.keyLevel,
          keyApi:  'Bearer '+ this.currentRow.keyApi,
          expirationTime: this.currentRow.expirationTime,
          email: this.currentRow.email,
          isSurvive: this.currentRow.isSurvive,
        };

        // 检查过期时间是否为空
        if (!requestBody.expirationTime) {
          this.$message.error('过期时间不能为空');
          return;
        }

        // 发送 POST 请求到 /save 路径
        const response = await axios.post(`/api/admin/apiKeys/save`, requestBody, {
          headers: {
            'token': this.$cookies.get('token') // 通过请求头发送token
          }
        });

        // 处理正常响应
        const result = this.requireSuccess(response);
        this.dialogVisible = false;
        this.$message.success(result.msg || 'key成功添加，运行池自动同步');

        // 可能需要更新列表或执行其他相关操作
        // ...
        await this.fetchApikeys();

      } catch (error) {
        // 处理错误
        this.$message.error('key添加失败: ' + this.errorMessage(error));
      } finally {
        // 结束添加请求，无论成功或失败，设置loading为false
        this.loading = false;
      }
    },
    handleDialogClose() {
      // 对话框关闭时的处理
      this.currentRow = {}; // 清空当前行数据
      this.dialogVisible = false;
    },
    async fetchApikeys() {
      try {
        this.loading = true; // 开始加载数据前设置loading为true

        // 创建 POST 请求的请求体
        const requestBody = {
          keyLevel: this.searchForm.keyka,
          current: this.currentPage,
          size: this.pageSize
        };

        const response = await axios.post(`/api/admin/apiKeys/page`, requestBody, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        // 处理响应数据
        this.requireSuccess(response);
        this.kamils = response.data.data.map(k => ({
          ...k,
          createTime: this.formatDate(k.createTime) // 假设您有一个formatDate方法
        }));

        this.totalKamils = response.data.total;
        await this.fetchPoolStatus();
      } catch (error) {
        // 处理错误
        this.$message.error('读取key失败: ' + this.errorMessage(error));
      } finally {
        this.loading = false; // 无论成功或失败，加载完成后设置loading为false
      }
    },
    handleSearch() {
      // 搜索触发重新获取数据
      this.fetchApikeys();
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchApikeys();
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    }
  },
  mounted() {
    this.fetchApikeys();
    this.fetchPoolStatus();
    this.poolPollTimer = window.setInterval(() => this.fetchPoolStatus(), 5000);
  },
  beforeDestroy() {
    window.clearInterval(this.poolPollTimer);
  }
}
</script>

<style scoped>
.search-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.search-input {
  margin-right: 10px;
}

.pool-hint {
  color: #909399;
  font-size: 12px;
  text-align: left;
}

.pool-alert {
  margin-top: 8px;
}

.pool-state {
  text-align: left;
  line-height: 22px;
  font-size: 12px;
  white-space: normal;
}

.pool-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 3px 0;
}

.app-container /deep/ .el-table th {
  background-color: #f5f7fa;
}

.app-container /deep/ .el-table td, .app-container /deep/ .el-table th {
  padding: 8px 0;
}

.app-container /deep/ .el-table .cell {
  line-height: 30px;
}

/* 为表格行添加样式 */
.el-table .el-table__row {
  line-height: 1.5!important; /* 设置行高 */
  max-height: 50px!important; /* 设置最大高度 */
  overflow: hidden!important; /* 隐藏溢出的内容 */
}

/* 为单元格内容添加样式 */
.el-table .cell {
  white-space: nowrap !important; /* 不允许内容换行 */
  text-overflow: ellipsis!important; /* 文本溢出时显示省略号 */
  overflow: hidden!important; /* 隐藏溢出的文本 */
}
/* 添加更多的自定义样式 */
</style>
